import { NSLine } from 'namirasoft-site-react';
import { NSARouterMakerResult } from 'namirasoft-account-react';
import { InvoiceRow } from 'namirasoft-payment';
import { PaymentProps } from '../PaymentProps';
import Styles from './NSPInvoiceCard.module.css';
export interface NSPInvoiceCardProps extends NSARouterMakerResult, PaymentProps
{
	invoice: InvoiceRow | null;
}
function NSPInvoiceCard(props: NSPInvoiceCardProps)
{
	return (
		<div className={Styles.nsp_invoce_card_container}>
			<div className={Styles.nsp_invoce_card_top_segment}>
				<h2>Invoice Number</h2>
				<p>{props.invoice?.id}</p>
			</div>
			{/* tood: fix amount  */}
			<h6>{`You are going to pay $${props.invoice?.total_payable} `}</h6>
			<NSLine />
			<div className={Styles.nsp_invoce_card_description}>
				<h5>Description:</h5>
				<p>{props.invoice?.description}</p>
			</div>
		</div>
	);
}

export default NSPInvoiceCard;